import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/core/services/user.service';
import { IAlsdeBackground, AlsdeBackground } from 'src/app/core/models/background.model';
import { ApplicationWizard } from 'src/app/core/models/application-wizard.model';
import { USER_ROLES } from 'src/app/core/enums/user.enum';
import { AlsdeUser } from 'src/app/core/models/alsde-user.model';
import { APPLICATION_ACTION_COMPELTE_STATUSES, APPLICATION_STATUS } from 'src/app/core/enums/application.enum';
import { CertWizService } from 'src/app/core/services/cert-wiz.service';
import { UI_APPLIST_TYPE } from 'src/app/core/enums/ui.enum';
import { AppList } from 'src/app/core/models/applist.model';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss']
})
export class HomePageComponent implements OnInit {

  UI_APPLIST_TYPE = UI_APPLIST_TYPE;
  bgrData: IAlsdeBackground = new AlsdeBackground();
  appList: AppList;
  user: AlsdeUser;
  constructor(
    public userService: UserService,
    public certWizService: CertWizService,
  ) { 
    this.user = this.userService.getUser();
    this.appList = new AppList(this.userService);
  }

  ngOnInit(): void {
    this.userService.BackgroundService();
    this.userService.InprogressService();
    this.userService.bgrData.subscribe(x => this.bgrData = x );
    this.userService.appList$.subscribe(y => this.appList = y );
  }

  filteredAppList(isComplete:boolean) {
    return this.appList.all
    .filter((app)=>{
      if(isComplete){
        return APPLICATION_ACTION_COMPELTE_STATUSES.includes(app.status?.Value || APPLICATION_STATUS.STARTED);
      }else{
        return !APPLICATION_ACTION_COMPELTE_STATUSES.includes(app.status?.Value || APPLICATION_STATUS.STARTED);
      }
    }).map((i: any) => {
      let isActionPending = (i.actionableRoles || []).find((requireRole: USER_ROLES) => { return this.user.roles.includes(requireRole) });
      if (isActionPending) {
        i.isActionPending = true;
      }
      return i;
    })
  }
}
